import React from 'react';
import BatchCodeManagement from '../../../components/inventory/BatchCodeManagement';

const BatchCode = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6">
      <BatchCodeManagement />
    </div>
  );
};

export default BatchCode;

